export enum ReferralMatchType {
  provider = 'provider',
  specialty = 'specialty',
  office = 'office',
  client = 'client',
  peerClientReferralVerification = 'peerClientReferralVerification',
  ehr = 'ehr',
}
